
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-eu",
      function () {
        return require("private-next-pages/en-eu/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en-eu"])
      });
    }
  